var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('vue-simple-markdown',{attrs:{"id":"yourElement","source":_vm.$t(_vm.subject)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }